// ---------------------------------------------- modules import
import M from "materialize-css";
import React, {
  ChangeEvent,
  FormEvent,
  FunctionComponent,
  useEffect
} from "react";
import { Link, useParams } from "react-router-dom";

import { IUpdateFormProps } from "./common";
import { useAuth, useAlbum } from "./hooks";
import { ThemeContext } from "../../../contexts/themeContext";
import PermissionHelper from "../../../store/helpers/permissionHelper";
import { pattern } from "../../../store/helpers/validationHelper";

// ---------------------------------------------- the component
const UpdateForm: FunctionComponent<IUpdateFormProps> = ({ menuIndex }) => {
  // ---------------------------------------------- router state
  const { album_id } = useParams();

  // ---------------------------------------------- local state
  const { auth, profile } = useAuth();
  const { album, isAlbumValid, onChange, onUpdate } = useAlbum(
    menuIndex,
    album_id
  );

  // ---------------------------------------------- handlers
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => onChange(e.currentTarget.name, e.currentTarget.value);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    onUpdate(auth, profile, `/${PermissionHelper.getUrl(menuIndex)}`);
  };

  // ---------------------------------------------- effects
  useEffect(() => {
    const link = document.querySelector("#link");

    if (link) M.textareaAutoResize(link);
  });

  useEffect(() => {
    const modals = document.querySelectorAll(".modal");

    M.Modal.init(modals);
  }, []);

  // ---------------------------------------------- content
  return profile ? (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <div className="container row">
          <form className="card col s12 m10 offset-m1" onSubmit={handleSubmit}>
            <div
              className="card-content row"
              style={{ marginBottom: "0px", paddingBottom: "0px" }}
            >
              <span style={{ fontSize: "0.75rem" }}>
                {PermissionHelper.getName(menuIndex).toLowerCase()}
              </span>

              <span className="card-title" style={{ marginBottom: "20px" }}>
                UPDATE FORM
              </span>

              <div className="input-field col s12 m6">
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="validate"
                  pattern={pattern.album.name.toString().slice(1, -1)}
                  minLength={2}
                  maxLength={50}
                  value={album.name}
                  onChange={handleChange}
                  required
                />

                <label className="active" htmlFor="name">
                  Name
                </label>
              </div>

              <div className="input-field col s12 m6">
                <textarea
                  id="link"
                  name="link"
                  className="materialize-textarea"
                  maxLength={200}
                  value={album.link}
                  onChange={handleChange}
                />

                <label className="active" htmlFor="link">
                  Album Link
                </label>
              </div>
            </div>

            <div className="card-action row" style={{ marginBottom: "0" }}>
              <div className="col s6">
                <Link
                  to={`/${PermissionHelper.getUrl(menuIndex)}`}
                  className="btn-floating btn-small waves-effect waves-light"
                  style={{ backgroundColor: theme.ui }}
                >
                  <i className="material-icons left">arrow_back</i>
                </Link>
              </div>

              <div className="col s6 right-align">
                <button
                  type="button"
                  className={`btn-small waves-effect waves-light modal-trigger ${
                    isAlbumValid() ? "" : "disabled"
                  }`}
                  style={{ backgroundColor: theme.ui }}
                  data-target="alert"
                >
                  Submit<i className="material-icons right">send</i>
                </button>

                <div className="modal" id="alert">
                  <div className="modal-content center">
                    <h5>Confirm Update</h5>

                    <p>{`Are you sure you want to update this album}?`}</p>
                  </div>

                  <div className="modal-footer">
                    <div className="container">
                      <button
                        type="submit"
                        className="btn modal-close"
                        style={{ backgroundColor: theme.ui }}
                      >
                        Yes, I'm sure
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      )}
    </ThemeContext.Consumer>
  ) : null;
};

export default UpdateForm;
